import { useOrganization } from '@/contexts/organization-context';
import { useOrganizationFeatureAccess } from '@/hooks/use-feature-gates';

/**
 * Whether the agentic home takes the dashboard's place for the current office. It needs its
 * own gate and the Pulse AI one, since every brief on the page is handed to Pulse AI. Closed
 * until the office's gates have been read, and again whenever a read of them does not answer:
 * `fetchFeatureGateAccess` gives that back as every gate off.
 */
export function useAgenticHomeEnabled(): boolean {
  const { currentOrganization } = useOrganization();
  const { data: access } = useOrganizationFeatureAccess(currentOrganization?.id);
  return access?.agentic_home === true && access.pulse_ai === true;
}
